import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import React from 'react';

const EditFormButton = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();
  };
  return (
    <PrimaryButtonComponent functionName={handleSubmit} span="Edit Form" />
  );
};

export default EditFormButton;
